export enum DataSpecification {
    GBFS = 'gbfs',
    GTFS = 'gtfs',
    MDS = 'mds'
}
